<template>
  <div class="manual-payments">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    <artmisads-segmented-tabs v-model="activeTab" :items="programConfig" :disabled="load" @change="onTabChange" />
    <div class="filters">
      <div class="search">
        <div class="option">
          <span>Username</span>
          <artmisads-select :clearable="true" show-search v-model:value="filters.sellerId" style="width: 232px"
            :options="sellerOptions" @search="searchSeller" :show-arrow="false" :filter-option="false"
            :not-found-content="null" @change="handleChangeSeller" placeholder="All" allowClear />
        </div>
        <div class="option" ref="marketplaceRef">
          <span>Marketplace</span>
          <!-- <artmisads-input v-model:value="filters.marketplace" @press-enter="getPartData({})"
            placeholder="Enter Marketplace"></artmisads-input> -->
          <artmisads-select :clearable="true" style="width: 232px" v-model:value="filters.marketplace"
            :getPopupContainer="() => $refs.marketplaceRef" :options="COUNTRY_BASE_OPTIONS" />
        </div>
        <div class="option">
          <span>Email</span>
          <artmisads-input v-model:value="filters.email" 
            placeholder="Enter Email" :allowClear="true"></artmisads-input>
        </div>
        <div class="option">
          <span>Brand</span>
            <artmisads-input v-model:value="filters.brandName" :clearable="true"
            placeholder="Enter BrandName"></artmisads-input>
          <!-- <artmisads-select :clearable="true" show-search v-model:value="filters.brandId" style="width: 232px"
            :options="brandOptions" @search="searchBrand" :show-arrow="false" :filter-option="false"
            :not-found-content="null" placeholder="All" allowClear /> -->
        </div>
        <div class="option" v-if="activeTab=='2'">
          <span>Publisher</span>
            <artmisads-input v-model:value="filters.publisherName" :clearable="true"
            placeholder="Enter PublisherName"></artmisads-input>
          <!-- <artmisads-select :clearable="true" show-search v-model:value="filters.publisherId" style="width: 232px"
            :options="publisherOptions" @search="searchPublisher" :show-arrow="false" :filter-option="false" @change="handleChangePublisher"
            :not-found-content="null" placeholder="All" allowClear /> -->
        </div>
        <!-- <div class="option" ref="statusRef">
          <span>creatDate</span>
          <a-date-picker :clearable="true" :show-time="true" format="YYYY-MM-DD HH:mm:ss" v-model:value="filters.createdAtStart" style="width: 232px"/>      
        </div> -->

        <!-- <div class="option" ref="typeStatusRef">
          <span>Type</span>
          <artmisads-select :clearable="true" style="width: 232px" v-model:value="filters.operationType"
            :getPopupContainer="() => $refs.typeStatusRef" :options="STATUS_OPTIONS" />
        </div> -->
        <div class="option" ref="changeToRef" v-if="activeTab!='2'">
          <span>ChangeTo</span>
          <artmisads-select :clearable="true" style="width: 232px" v-model:value="filters.operationCategory"
            :getPopupContainer="() => $refs.changeToRef" :options="CHANGE_OPTIONS" />
        </div>
        <div class="option" ref="submitTimeToRef">
          <span>SubmitTime</span>
          <artemisads-range-picker :clearable="true" format="YYYY-MM-DD"  v-model:value="filters.executedAtEnd"
            style="width: 250px" />
        </div>
        <div class="option" v-if="activeTab=='1'">
          <span>ASIN</span>
           <artmisads-input v-model:value="filters.asin" 
            placeholder="Enter ASIN"></artmisads-input>
        </div>
      </div>

    </div>
    <div class="button">
      <artmisads-button isSquare="true" type="primary" style="margin-right: 12px" :loading="load"
        @click="searchList">Search</artmisads-button>
      <artmisads-button isSquare="true" @click="onReset">Reset</artmisads-button>
    </div>
    <div class="add">

      <artmisads-button isSquare="true" type="primary" @click="exportData">
        Export
      </artmisads-button>

    </div>
    <div class="table-data">
      <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="dataList"
        :change="onTableChange" :loading="load" :scroll="{ x: 1600, y: tableScrollHeight }">
        <template #bodyCell="{ record, index, column }">
          <template v-if="column.key === 'submitTime'">
            {{ record.createdAt ?
              moment(Number(record.createdAt)).tz(COUNTRY_TIME_TZ[record?.countryCode]).format('YYYY-MM-DD HH:mm:ss') : '--' }}
          </template>
          <template v-if="column.key === 'brand'">
            {{ returnBrandName(record) }}
          </template>
          <template v-if="column.key==='publisher'">
             {{ returnPublisherName(record) }}
          </template>
          <template v-if="column.key==='brandProduct'">
             {{ returnbrandProductName(record) }}
          </template>
          <template v-if="column.key==='asin'">
             {{ returnAsin(record) }}
          </template>
          <template v-if="column.key === 'effectiveTime'">
            {{ record.effectiveTime ?
              moment(Number(record.effectiveTime)).tz(COUNTRY_TIME_TZ[record?.countryCode]).format('YYYY-MM-DD HH:mm:ss') : '--' }}
          </template>
          <template v-if="column.key === 'userName'">
            {{ returnUserName(record) }}
          </template>
          <template v-if="column.key === 'email'">
            {{ returnEmail(record) }}
          </template>
          <template v-if="column.key === 'commissionChangeFrom'">
            {{ returnCommission(record,'changeFrom') }}
          </template>
          <template v-if="column.key === 'commissionChangeTo'">
            {{ returnCommission(record,'changeTo') }}
          </template>
            <template v-if="column.key === 'changeTo'">
            {{ returnChangeTo(record,'changeTo') }}
          </template>
          <template v-if="column.key === 'perlod'">
            {{ returnPerlod(record) }}
          </template>
          
        </template>
      </artmisads-table>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue'
import breadcrumbs from '../../breadcrumbs.vue'
import { COUNTRY_BASE } from '~/contants/common'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import Status from '@/components/Status.vue'
// import { financeApi } from '~/server/operator/finance'
import { sellerLogsApi } from '~/server/operator/sellerLogs'

import moment from 'moment'
import { BILLING_TIME_TZ } from '~/contants/common'
import { publisherAdminApi } from '~/server/index'
import { useUserInfoStore } from '@/storeData'

import { COUNTRY_TIME_TZ } from '~/contants/common.js'


import { CURRENCY_MAPPER, COUNTRY_SITE_CODE_MAP } from '~/contants/common'
const programConfig = ref([
  {
    label: 'Brands',
    key: '0',
  },
  {
    label: 'Product',
    key: '1',
  },
  {
    label: 'Partnerships',
    key: '2',
  }
])
const activeTab = ref('0')
const STATUS_OPTIONS = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Status',
    value: 'STATUS_CHANGE',
  },
  {
    label: 'Commission',
    value: 'COMMISSION_CHANGE',
  },
]
const CHANGE_OPTIONS = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'ACTIVE',
    value: 'ACTIVE',
  },
  {
    label: 'INACTIVE',
    value: 'INACTIVE',
  },
  // {
  //   label: 'COMMISSION_INCREASE',
  //   value: 'COMMISSION_INCREASE',
  // },
  // {
  //   label: 'COMMISSION_DECREASE',
  //   value: 'COMMISSION_DECREASE',
  // },
]
const columns = ref([
        {
          title: 'SubmitTime',
          key: 'submitTime',
          dataIndex: 'submitTime',
          align: 'center',
        },
        {
          title: 'UserName',
          dataIndex: 'userName',
          key: 'userName',
          align: 'center',
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          align: 'center',
        },
        {
          title: 'Brand',
          dataIndex: 'brand',
          key: 'brand',
          align: 'center',
        },
        {
          title: 'ChangeTo',
          dataIndex: 'changeTo',
          key: 'changeTo',
          align: 'center',
        },
        {
          title: 'EffectiveTime',
          dataIndex: 'effectiveTime',
          key: 'effectiveTime',
          align: 'center',
        },
      ])
const user = useUserInfoStore()
const countryCode = user?.userInfo?.countryCode || 'US'
const marketplace = CURRENCY_MAPPER[countryCode].host
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode || 'US']
const options = ref([])
const userId = ref('')
const dataList = ref([])
const modelRef = ref(null)
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
})
const marketplaceRef = ref(null)
const statusRef = ref(null)
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
})
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 280,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350,
})
const load = ref(false)
const statusOptions = ref([
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Paid',
    value: 'Paid',
  },
  {
    label: 'Unpaid',
    value: 'Unpaid',
  },
])
const breadcrumbsData = ref({
  title: 'Seller Logs - Associate',
  des: '',
  links: [
    {
      name: 'Home',
      path: '/operator/users',
    },
    {
      name: 'Operation',
      path: '/operator/operation/manualPayments',
    },
    {
      name: 'SellerLogs',
      path: '/operator/operation/sellerLogs/attribution',
    },
    {
      name: 'Associate',
      path: '/operator/operation/sellerLogs/associate',
    },
  ],
})
const sellerOptions = ref([])
const filters = ref({
  sellerId: '',
  marketplace: 'amazon.com',
  brandName: '',
  operationType: '',
  operationCategory: '',
  executedAtEnd: '',
  sellerName: '',
  email: '',
  publisherName: '',
})
const brandOptions = ref([])
const publisherOptions = ref([])

const userInfoArr = ref([])
const onTabChange = (key) => {
  activeTab.value = key
  filters.value = {
    sellerId: '',
    marketplace: 'amazon.com',
    brandName: '',
    operationType: '',
    operationCategory: '',
    executedAtEnd: '',
    sellerName: '',
    email: '',
    publisherName: '',
  }
  Object.assign(pagination, {
    current: 1,
    defaultPageSize: 10,
    size: 10,
    pageSize: 10,
    total: 50,
    pageSizeOptions: ['10', '20', '50', '100'],
    showSizeChanger: true,
  })

  switch (key) {
    case '0':
      columns.value = [
        {
          title: 'SubmitTime',
          key: 'submitTime',
          dataIndex: 'submitTime',
          align: 'center',
        },
        {
          title: 'UserName',
          dataIndex: 'userName',
          key: 'userName',
          align: 'center',
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          align: 'center',
        },
        {
          title: 'Brand',
          dataIndex: 'brand',
          key: 'brand',
          align: 'center',
        },
        {
          title: 'ChangeTo',
          dataIndex: 'changeTo',
          key: 'changeTo',
          align: 'center',
        },
        {
          title: 'EffectiveTime',
          dataIndex: 'effectiveTime',
          key: 'effectiveTime',
          align: 'center',
        },
      ]
      break
    case '1':
      columns.value = [
        {
          title: 'SubmitTime',
          key: 'submitTime',
          dataIndex: 'submitTime',
          align: 'center',
        },
        {
          title: 'UserName',
          dataIndex: 'userName',
          key: 'userName',
          align: 'center',
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          align: 'center',
        },
        {
          title:'ASIN',
          dataIndex: 'asin',
          key: 'asin',
          align: 'center',
        },
        {
          title: 'Brand',
          dataIndex: 'brandProduct',
          key: 'brandProduct',
          align: 'center',
        },

        {
          title: 'ChangeTo',
          dataIndex: 'changeTo',
          key: 'changeTo',
          align: 'center',
        },
        {
          title: 'EffectiveTime',
          dataIndex: 'effectiveTime',
          key: 'effectiveTime',
          align: 'center',
        },
      ]
      break
    case '2':
       columns.value = [
        {
          title: 'SubmitTime',
          key: 'submitTime',
          dataIndex: 'submitTime',
          align: 'center',
        },
        {
          title: 'UserName',
          dataIndex: 'userName',
          key: 'userName',
          align: 'center',
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          align: 'center',
        },
        {
          title: 'Brand',
          dataIndex: 'brand',
          key: 'brand',
          align: 'center',
        },
       {
          title: 'Publisher',
          dataIndex: 'publisher',
          key: 'publisher',
          align: 'center',
        },
        {
          title: 'CommissionChangeFrom',
          dataIndex: 'commissionChangeFrom',
          key: 'commissionChangeFrom',
          align: 'center',
          width: 220, 
        },
        {
          title: 'CommissionChangeTo',
          dataIndex: 'commissionChangeTo',
          key: 'commissionChangeTo',
          align: 'center',
           width: 220, 
        },
        {
          title: 'Perlod',
          dataIndex: 'perlod',
          key: 'perlod',
          align: 'center',
        },
        {
          title: 'EffectiveTime',
          dataIndex: 'effectiveTime',
          key: 'effectiveTime',
          align: 'center',
        },
      ]
    break    
  }
    getData({})
}
// const getUser = async (parma) => {
//   const res = await financeApi.getSensitiveProducts(parma)
//   let data = res.filter((v) => v.userType === 'seller')
//   options.value = data.map((item) => ({
//     label: item.email,
//     value: item.userId,
//   }))
//   userInfoArr.value = data
// }
const handleChangeSeller = (e) => {
  filters.value.sellerName = sellerOptions.value.find(v => v.value == e)?.label
}
const handleChangePublisher = (e) => {
  filters.value.publisherName = publisherOptions.value.find(v => v.value == e)?.label
}
const returnPerlod=(record)=>{
  const timeStrat = `${moment(Number(record?.commission?.startDate)).tz(COUNTRY_TIME_TZ[record?.countryCode]).format('YYYY-MM-DD HH:mm:ss')}`
  const timeEnd = `${moment(Number(record?.commission?.endDate)).tz(COUNTRY_TIME_TZ[record?.countryCode]).format('YYYY-MM-DD HH:mm:ss')}`
  if(timeStrat && timeEnd){
    return `${timeStrat} ~ ${timeEnd}`
  }
}
const searchSeller = async keyword => {
  const params = {
    keyword,
    marketplace: marketplace
  }
  let data = await publisherAdminApi.searchSeller(params)
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id
      item.label = item.sellerName
      item.sellerBrands = item.sellerBrands.map(i => {
        i.value = i.id
        i.label = i.amazonBrandName
        return i
      })
      return item
    })
    sellerOptions.value = data
  }
}
const searchBrand = async keyword => {
  const params = {
    keyword,
    marketplace: marketplace
  }
  let data = await publisherAdminApi.searchBrand(params)
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id
      item.label = item.amazonBrandName
      return item
    })
    brandOptions.value = data
  }
}
const searchPublisher = async keyword => {
  const params = {
    keyword,
    marketplace: marketplace
  }
  let data = await publisherAdminApi.searchPublisher(params)
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id
      item.label = item.creatorName
      return item
    })
    publisherOptions.value = data
  }
}
const searchList = async () => {
  // console.log(filters.value)
  pagination.current = 1
  getData(filters.value)
}
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
const bulkUpdateModelRef = ref(null)
const returnBrandName = (record) => {
  const brand = `${record?.brand?.amazonBrandName}${record?.brand?.amazonProfileAccountInfoName ? `(${record?.brand?.amazonProfileAccountInfoName})` : ''}`
  return brand
}
const returnPublisherName=(record)=>{
  const publisher = `${record?.publisher?.creatorName}`
  return publisher
}
const returnbrandProductName=(record)=>{
  const brand = `${record?.product?.brandName}`
  return brand
}
const returnAsin=(record)=>{
  const asin = `${record?.product?.asin}`
  return asin
}
const returnUserName=(record)=>{
  const userName = `${record?.seller?.sellerName}`
  return userName
}
const returnEmail=(record)=>{
  const email = `${record?.seller?.email}`
  return email
}
const returnCommission=(record,type)=>{
 if(type === 'changeFrom'){
  if(Object.keys(record.changeFrom).length){
    return record?.changeFrom.commissionRate+'%'
  }
  }
 if(type === 'changeTo'){
  if(Object.keys(record.changeTo).length){
  return record?.changeTo.commissionRate+'%'
  }
  }
}
const returnChangeTo=(record,type)=>{
  if(type === 'changeTo'&&typeof record?.changeTo === 'string'){
    let obj=JSON.parse(record?.changeTo)
   return obj?.associateStatus
  }
}
const exportData = () => {
  const params = {
    ...filters.value,
    page: pagination.current,
    size: pagination.size,
    businessLine: 'ASSOCIATE'
  }
  if (params.executedAtEnd) {
    const startDate = params.executedAtEnd[0].format('YYYY-MM-DD')+' 00:00:00'
    const endDate = params.executedAtEnd[1].format('YYYY-MM-DD')+' 23:59:59'
    params.createdAt = moment(startDate).valueOf()
    params.createdAtEnd = moment(endDate).valueOf()
  }

  if (params.marketplace) {
    params.countryCode = COUNTRY_SITE_CODE_MAP[params.marketplace]
  }
  switch (activeTab.value) {
    case '0':
       sellerLogsApi.exportSellerBrandChangeLogs({
    qs: params,
    fileName: `seller_brand_change_logs_attribution_${moment().format('YYYY-MM-DD')}.csv`,
    platform: 'operator'
  })
      break
    case '1':
      sellerLogsApi.exportSellerProductChangeLogs({
    qs: params,
    fileName: `seller_product_change_logs_attribution_${moment().format('YYYY-MM-DD')}.csv`,
    platform: 'operator'
  })
      break
      case '2':
        sellerLogsApi.exportSellerPartnershipChangeLogs({
    qs: params,
    fileName: `partnership_logs_attribution_${moment().format('YYYY-MM-DD')}.csv`,
    platform: 'operator'
  })
        break
  }

}


const onReset = () => {
  filters.value = {
    sellerId: '',
    marketplace: 'amazon.com',
    brandId: '',
    operationType: '',
    operationCategory: '',
    executedAtEnd: '',
    sellerName: ''
  }
  getData({})
}
const onTableChange = ({ current, pageSize }) => {
  // console.log(current, pageSize,'数据')
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getData({ page: current, size: pageSize })
}
const getData = async (params) => {
  load.value = true
  if (Object.keys(params).length === 0) {
    pagination.current = 1
  }
  let _params = {
    page: pagination.current,
    size: pagination.size,
    ...filters.value,
    businessLine: 'ASSOCIATE'
    // marketplace: filters.marketplace,
    // sellerId: filters.sellerId,
    // bd: filters.bd
  }

  if (_params.executedAtEnd) {
    const startDate = params.executedAtEnd[0].format('YYYY-MM-DD')+' 00:00:00'
    const endDate = params.executedAtEnd[1].format('YYYY-MM-DD')+' 23:59:59'
    _params.createdAt = moment(startDate).valueOf()
    _params.createdAtEnd = moment(endDate).valueOf()
  }
  if (_params.marketplace) {
    _params.countryCode = COUNTRY_SITE_CODE_MAP[_params.marketplace]
  }
  let newparams = { ..._params }
  newparams = Object.keys(newparams).reduce((acc, key) => {
    if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ''
    ) {
      acc[key] = newparams[key]
    }
    return acc
  }, {})
  // console.log(activeTab.value,'activeTab.value')
  switch (activeTab.value) {
    case '0':
      // console.log('执行1334')
      sellerLogsApi
        .getSellerBrandChangeLogs(newparams)
        .then((res) => {

          if (res.success) {
            dataList.value = res.data.data
            pagination.total = res.data.total
          }
        })
        .finally(() => {
          load.value = false
        })
      break
    case '1':
      sellerLogsApi
        .getSellerProductChangeLogs(newparams)
        .then((res) => {

          if (res.success) {
            dataList.value = res.data.data
            pagination.total = res.data.total
          }
        })
        .finally(() => {
          load.value = false
        })
      break
     case '2':
      sellerLogsApi
        .getSellerPartnershipChangeLogs(newparams)
        .then((res) => {
          console.log(12333)
          if (res.success) {
            dataList.value = res.data.data
            dataList.value.forEach(item => {
              if(typeof item?.changeFrom === 'string'){
             item.changeFrom=item?.changeFrom?JSON.parse(item?.changeFrom):{}

              }
              if(typeof item?.changeTo === 'string'){
             item.changeTo=item?.changeTo?JSON.parse(item?.changeTo):{}

              }
            })
            // console.log(dataList.value,'dataList.value')
            pagination.total = res.data.total
          }
        })
        .finally(() => {
          load.value = false
        })
      break
  }
  
}

const edit = (record) => {
  console.log(record, 'record')
}
const view = (record) => {
  console.log(record, 'record')
}
const revoke = (record) => {
  console.log(record, 'record')
}
getData({})
// onMounted(() => {
//   getData({})
// })
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
</script>
<style scoped lang="less">
.button {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  justify-content: flex-end;
}

.autoComplete {
  :deep(.ant-select-selector) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-search-input) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-placeholder) {
    line-height: 32px !important;
  }
}

.add {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
  gap: 12px;
}

.manual-payments {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}

.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    >a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      >span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}

.filters {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .option {
      >span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}
</style>
